import { BaseList } from "App/Screens/SubModules/Component";
import descriptor from "./descriptorOffline";

class AccountList extends BaseList {
  constructor(props) {
    super(props)

    this.appName = 'jobs'
    this.modelName = 'account'
    this.propsList = {
      avatar: 'account_name',
      pageTitle: 'Account',
      descriptor,
      masterKey: 'module-merchant-account',
    }
  }
}

export default AccountList